/** OSRS-style server tick length. Client `TickClock` and the multiplayer server use the same values. */
export const OSRS_TICK_MS = 600;
export const OSRS_TICK_SECONDS = OSRS_TICK_MS / 1000;
